// Collection list
class HeliosCollectionList extends HTMLElement {
    connectedCallback() {
        this.scrollActive();
    }

    scrollActive() {
        const active = this.querySelector('.active');

        if (!active) return;
        const container = this.querySelector('.js__list-container');

        const start = container.scrollLeft;
        const target = active.offsetLeft;
        const duration = 1200;

        let startTime = null;

        function animate(currentTime) {
            if (!startTime) startTime = currentTime;

            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);

            const ease = progress < 0.5
                ? 2 * progress * progress
                : 1 - Math.pow(-2 * progress + 2, 2) / 2;

            container.scrollLeft = start + (target - start - 20) * ease;

            if (elapsed < duration) {
                requestAnimationFrame(animate);
            }
        }

        requestAnimationFrame(animate);
    }
}

if (!customElements.get('helios-collection-list')) {
    customElements.define('helios-collection-list', HeliosCollectionList);
}
